import { render, staticRenderFns } from "./MerchandisingFieldsDetail.vue?vue&type=template&id=aa8da8c4"
import script from "./MerchandisingFieldsDetail.vue?vue&type=script&lang=js"
export * from "./MerchandisingFieldsDetail.vue?vue&type=script&lang=js"
import style0 from "./MerchandisingFieldsDetail.vue?vue&type=style&index=0&id=aa8da8c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports